import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, Marker, useLoadScript, Circle } from "@react-google-maps/api";
import { MDBBtn, MDBInput, MDBAlert, MDBFooter, MDBModalBody } from "mdb-react-ui-kit";

import { logEvent, saveGymCoordinates } from "../services/apiServices";
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../hooks/useAnalytics';



const mapContainerStyle = {
    height: "100%",
    width: "100%",
};


const defaultCenter = { lat: 17.385044, lng: 78.486671 };

const GoogleMapComponent = ({ onSuccess, handleCancel, gymCoordinatesprops, onStatusChange }) => {

    const { trackButtonClick } = useAnalytics();
    const frontEndEnvData = localStorage.getItem("frontEndEnvData");
    const googleMapsApiKey = frontEndEnvData ? JSON.parse(frontEndEnvData)?.googleMapsApiKey : "AIzaSyD65RKBAGVtP_QeI-cF-NnEjpN6GBtcOVg";


    console.log(googleMapsApiKey, "googleMapsApiKey")

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: googleMapsApiKey,
        libraries: ["places"],
    });

    const [location, setLocation] = useState(null);
    const [gymCoordinates, setGymCoordinates] = useState();
    const [limit, setLimit] = useState(gymCoordinatesprops?.maxdistance ?? 100);
    const [radius, setRadius] = useState(limit);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    // const [enable, setEnable] = useState(gymCoordinatesprops?.enable || false);
    const popupRef = useRef(null);


    const resetState = () => {

        setSearchQuery("");
        setSearchResults([]);
    };



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                resetState();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);



    const mapRef = useRef(null);
    const onMapLoad = (map) => {
        mapRef.current = map;
    };

    const [zoomInCount, setZoomInCount] = useState(0);
    const [zoomOutCount, setZoomOutCount] = useState(0);
    const [currentZoom, setCurrentZoom] = useState(12);
    const [minZoom, setMinZoom] = useState(undefined);
    const [maxZoom, setMaxZoom] = useState(undefined);
    useEffect(() => {
        setRadius(limit);
    }, [limit]);


    const handleZoomChange = () => {
        if (mapRef.current) {
            const newZoom = mapRef.current.getZoom();

            if (newZoom > currentZoom) {

                if (zoomInCount < 5) {
                    setZoomInCount(prev => prev + 1);
                    setZoomOutCount(0);
                    setMinZoom(undefined);
                }

                if (zoomInCount + 1 >= 5) {
                    setMaxZoom(newZoom);
                }
            }
            else if (newZoom < currentZoom) {

                if (zoomOutCount < 8) {
                    setZoomOutCount(prev => prev + 1);
                    setZoomInCount(0);
                    setMaxZoom(undefined);
                }

                if (zoomOutCount + 1 >= 8) {
                    setMinZoom(newZoom);
                }
            }

            setCurrentZoom(newZoom);
        }
    };


    useEffect(() => {
        if (gymCoordinatesprops) {
            const { lat, lng } = gymCoordinatesprops;
            setGymCoordinates({ lat, lng });
        }
    }, [gymCoordinatesprops]);




    const handleMapClick = (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setLocation({ lat, lng });
        setSelectedLocation(null);
    };

    const performSearch = (query) => {
        if (!query || !mapRef.current) {
            setSearchResults([]);
            return;
        }
        const service = new window.google.maps.places.PlacesService(mapRef.current);
        const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(8.0666, 68.1113),
            new window.google.maps.LatLng(37.1000, 97.3956)
        );
        const request = { query, bounds };
        service.textSearch(request, (results, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && results && results.length > 0) {
                setSearchResults(results);
            } else {
                setSearchResults([]);
            }
        });
    };


    const handleSearchInputChange = (e) => {
        const query = e?.target?.value ?? "";
        setSearchQuery(query);
        performSearch(query);
    };



    const handleSelectLocation = (result) => {
        const lat = result.geometry.location.lat();
        const lng = result.geometry.location.lng();
        setSelectedLocation({ lat, lng, display_name: result.formatted_address || result.name });
        setLocation(null);
        setGymCoordinates(null)
        setSearchResults([]);
        setSearchQuery(result.formatted_address || result.name);
        if (mapRef.current) {
            mapRef.current.panTo({ lat, lng });
        }
    };


    const handleSaveLocation = async () => {
        const bid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid || "";
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
        const username1 = userInfo?.email || "User";
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";

        if (!bid) {
            console.error("Gym ID is missing");
            return;
        }

        const saveData = selectedLocation
            ? { lat: selectedLocation.lat, lng: selectedLocation.lng, bid }
            : location
                ? { lat: location.lat, lng: location.lng, bid }
                : gymCoordinates
                    ? { lat: gymCoordinates.lat, lng: gymCoordinates.lng, bid }
                    : null;


        const updates = {
            maxdistance: limit,
            data: saveData,
            // enable: enable,
        }


        if (!saveData) {
            console.log("No location selected to save.");
            return;
        }

        try {
            const response = await saveGymCoordinates(bid, updates);
            console.log(response)



            setGymCoordinates(saveData);
            onStatusChange("Gym location saved successfully");
            await trackButtonClick("GeoLocation", "Updated_Geo_Location", "staff", {});
            handleCancel()
            onSuccess();
            setLocation(null);
            setSelectedLocation(null);

            const ip = localStorage.getItem("ipaddress");
            const browserinfo = `${browserName}-${browserVersion}.0.0`;
            const flag = `geo location updated by (${fullName})`;

            await logEvent({
                Eventtype: "Geo-Location Update",
                username1,
                ip,
                flag,
                browserinfo,
                gymid: bid
            }, bid);


        } catch (error) {
            console.error("Error saving location:", error);
        }
    };

    if (loadError) return <div>Error loading maps</div>;
    if (!isLoaded) return <div>Loading Maps...</div>;


    const customIcon = {
        url: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
        scaledSize: new window.google.maps.Size(40, 40),
        anchor: new window.google.maps.Point(20, 40),
    };


    return (
        <>
            <MDBModalBody ref={popupRef}>
                {/* <h5 className="card-title">
                    <label>Enable geo-fence staff check-In</label>
                    <div className="phoneselect">
                        <label className="m-0 ms-2 switch"
                            onChange={() => setEnable(!enable)}
                        >
                            <input className="form-control" type="checkbox" checked={enable} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </h5> */}
                {
                    // enable &&
                    <div>
                    <div>
                        <MDBInput
                            label="Search for a location"
                            type="text"
                            value={searchQuery ?? ""}
                            onChange={handleSearchInputChange}
                        />
                    </div>
                    {searchQuery && searchResults.length === 0 && !selectedLocation && (
                        <div className="select-options-wrapper">
                            <div className="select-options-list locationSelectDropdown shadow-4">
                                <div className="select-option text-center ">
                                    No matching data found
                                </div>
                            </div>
                        </div>
                    )}


                    {searchResults.length > 0 && (
                        <div class="select-options-wrapper">
                            <div class="select-options-list locationSelectDropdown shadow-4">
                                {searchResults.map((result, index) => (
                                    <div class="select-option"
                                        key={index}
                                        onClick={() => handleSelectLocation(result)}
                                    >
                                        <span class="select-option-text">{result.formatted_address || result.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}


                    <div className="mt-2" style={{ height: "550px" }}>
                        <GoogleMap
                            center={
                                gymCoordinates?.lat && gymCoordinates?.lng
                                    ? gymCoordinates
                                    : location?.lat && location?.lng
                                        ? location
                                        : selectedLocation?.lat && selectedLocation?.lng
                                            ? selectedLocation
                                            : defaultCenter
                            }

                            zoom={12}
                            mapContainerStyle={mapContainerStyle}
                            onClick={handleMapClick}
                            onLoad={(map) => {
                                onMapLoad(map);
                                mapRef.current = map;
                                map.addListener("zoom_changed", handleZoomChange);
                            }}

                            options={{
                                mapTypeControl: false,
                                streetViewControl: false,
                                fullscreenControl: true,
                                zoomControl: true,
                                disableDefaultUI: true,
                                minZoom: minZoom,
                                maxZoom: maxZoom
                            }}
                        >

                            {gymCoordinates && !selectedLocation && !location && (
                                <>
                                    <Marker position={{ lat: gymCoordinates.lat, lng: gymCoordinates.lng }} icon={customIcon} />
                                    <Circle
                                        center={{ lat: gymCoordinates.lat, lng: gymCoordinates.lng }}
                                        radius={radius}
                                        options={{
                                            strokeColor: "#00FF00",
                                            strokeOpacity: 0.8,
                                            strokeWeight: 2,
                                            fillColor: "#00FF00",
                                            fillOpacity: 0.35,
                                        }}
                                    />
                                </>
                            )}


                            {selectedLocation && (
                                <>
                                    <Marker position={{ lat: selectedLocation.lat, lng: selectedLocation.lng }} icon={customIcon} />
                                    <Circle
                                        center={{ lat: selectedLocation.lat, lng: selectedLocation.lng }}
                                        radius={radius}
                                        options={{
                                            strokeColor: "#00FF00",
                                            strokeOpacity: 0.8,
                                            strokeWeight: 2,
                                            fillColor: "#00FF00",
                                            fillOpacity: 0.35,
                                        }}
                                    />
                                </>
                            )}


                            {location && !selectedLocation && (
                                <>
                                    <Marker position={{ lat: location.lat, lng: location.lng }} icon={customIcon} />
                                    <Circle
                                        center={{ lat: location.lat, lng: location.lng }}
                                        radius={radius}
                                        options={{
                                            strokeColor: "#00FF00",
                                            strokeOpacity: 0.8,
                                            strokeWeight: 2,
                                            fillColor: "#00FF00",
                                            fillOpacity: 0.35,
                                        }}
                                    />
                                </>
                            )}

                        </GoogleMap>
                    </div>

                    <div className="mt-4 position-relative">
                        <MDBInput
                            type="number"
                            className="form-control d-inline-block w-auto"
                            placeholder="meters"
                            label="Range"
                            value={limit}
                            min={1}

                            onChange={(e) => {
                                const newValue = e.target.value;
                                if (newValue === "" || Number(newValue) > 0) {
                                    setLimit(newValue);
                                    setRadius(Number(newValue));
                                }
                            }}
                        />
                        <label className="position-absolute range-text">
                                Staff Login Range
                        </label>
                    </div>
                </div>}
            </MDBModalBody>

            <MDBFooter className="justify-content-end d-flex pb-3 pe-3">
                <MDBBtn color="secondary" onClick={handleCancel} className="me-2">
                    cancel
                </MDBBtn>
                <MDBBtn color="primary" onClick={handleSaveLocation}>
                    Save Location
                </MDBBtn>
            </MDBFooter>


        </>
    );
};

export default GoogleMapComponent;